import { render, staticRenderFns } from "./StartTrainExam.vue?vue&type=template&id=cba2b02e&scoped=true&"
import script from "./StartTrainExam.vue?vue&type=script&lang=js&"
export * from "./StartTrainExam.vue?vue&type=script&lang=js&"
import style0 from "./StartTrainExam.vue?vue&type=style&index=0&id=cba2b02e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba2b02e",
  null
  
)

export default component.exports